import { render } from "./WelcomeComponent.vue?vue&type=template&id=c4139134"
import script from "./WelcomeComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__